/*jshint esversion: 8 */
import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { observer } from "mobx-react";
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

// add dialog
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import { addRole, getAllRoles } from '../../../db/SystemOperationRequestHandler';
import store from '../../../components/stores/Store';
import { getIfFuncAuthorized } from '../../../utils/CheckSomething';
import ITextField from '../../../components/UI/ITextField';
import CheckHandler from '../../../utils/CheckHandler';

const styles = {
  root: {},
  textField: {
    width: '15ch',
  },
  formControl: {
    margin: '10px',
    // width: '20ch',
    minWidth: '20ch',
  },
  rootform: {
    textAlign: 'left',
  },
  button: {
    marginLeft: '10px',
    marginTop: '10px',
  }
};
// src/pages/SystemManagement/AuthorizationManagement/Authorization.js
// NavigateLeft
class SelectionOfAuthorizationManagementInner extends Component {
  constructor() {
    super();
    this.state = {
      addDialogOpen: false,
      addDialogParams: {
        roleName: '',
      },
    };
    this.addNew = this.addNew.bind(this);
    this.search = this.search.bind(this);
    this.onDialogChange = this.onDialogChange.bind(this);
  }

  componentDidMount() {
    this.search();
    store.search = this.search;
  }
  componentWillUnmount() { }

  onDialogChange(e, prop) {
    const newAddDialogParams = this.state.addDialogParams;
    newAddDialogParams[prop] = e.target.value;
    e.stopPropagation();
    this.setState({ addDialogParams: newAddDialogParams });
  }

  async addNew() {
    const roleName = this.state.addDialogParams.roleName.trim();

    const chkRst = CheckHandler.checkParams([
      { key: '角色名称', value: roleName, notNull: true, type: '', maxLength: 10 }
    ]);

    if (chkRst.msg) {
      store.openMessageDialogOpen(chkRst.msg);
      return;
    }

    const rst = await addRole(this.state.addDialogParams);
    console.log(`----- rst of addRole: `, rst);
    if (rst.code === 'error') {
      store.openMessageDialogOpen(rst.msg || '系统错误');
      return true;
    } else if (rst.code === 'success') {
      console.log(`----- rst: `, rst);
      store.openMessageDialogOpen(rst.msg || '添加成功');
      this.setState({ addDialogOpen: false });
      this.search();
      return true;
    }
  }

  async search() {
    if (!getIfFuncAuthorized('系统管理-权限管理-查找')) {
      store.openMessageDialogOpen('权限不足');
      return;
    }
    const rst = await getAllRoles({});
    if (rst.code === 'error') {
      store.openMessageDialogOpen('查询错误');
      return true;
    } else if (rst.code === 'success') {
      console.log(`----- search rst: `, rst);
      store.setRoleTable(rst.data);
      return true;
    }
  }
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <form className={classes.rootform} noValidate autoComplete="off">
          {(getIfFuncAuthorized('系统管理-权限管理-添加')) && (
            <Button color="primary" variant="contained"
              aria-label="contained primary button group"
              className={classes.button}
              onClick={e => this.setState({
                addDialogOpen: true,
                addDialogParams: {
                  roleName: '',
                },
              })}
            >添加</Button>
          )}
          <Button color="primary" variant="contained"
            aria-label="contained primary button group"
            className={classes.button}
            onClick={this.search}
          >刷新</Button>
        </form>

        <Dialog aria-labelledby="form-dialog-title"
          open={this.state.addDialogOpen}
          onClose={e => this.setState({ addDialogOpen: false })}>
          <DialogTitle id="form-dialog-title" style={{ width: '300px' }}>添加角色</DialogTitle>
          <DialogContent>
            <ITextField
              autoFocus
              margin="dense"
              id="name"
              label="角色名称"
              fullWidth

              ivalue={this.state.addDialogParams.roleName}
              onChange={e => this.onDialogChange(e, 'roleName')}
              type=""
              maxLength='10'
              notNull
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.addNew} color="primary" variant="contained"
              aria-label="contained primary button group">
              确认添加
            </Button>
            <Button onClick={e => this.setState({ addDialogOpen: false })}
              color="primary" variant="contained"
              aria-label="contained primary button group">
              取消
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

const SelectionOfAuthorizationManagement = observer(SelectionOfAuthorizationManagementInner);

SelectionOfAuthorizationManagement.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SelectionOfAuthorizationManagement);
